import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewOrderSubmittedDialogComponent } from '../review-order-submitted-dialog/review-order-submitted-dialog.component';
import { ModalService } from '../services/modal.service';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'submit-for-review-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReviewOrderSubmittedDialogComponent,
    ModalComponent,
  ],
  templateUrl: './submit-for-review-dialog.component.html',
  styleUrl: './submit-for-review-dialog.component.scss',
})
export class SubmitForReviewDialogComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Input() siteId: string = '';
  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() submitReview = new EventEmitter<String>();
  @Output() submitRevision = new EventEmitter<String>();

  @Input() documents: any = '';
  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() status: string = '';
  @Input() isAlta = false;

  deliverableDocuments: any = [];
  isSubmitting = false;
  isReviewOrderSubmitted: boolean = false;
  dialogTitle = '';
  dialogMessage = '';

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    if (this.isAlta) {
      this.dialogTitle = this.status === 'ACTIVE' ? 'Deliverable' : 'Revision';
      this.dialogMessage =
        this.status === 'ACTIVE' ? 'deliverable' : 'revision';
    } else {
      this.dialogTitle = 'Project';
      this.dialogMessage = 'project';
    }
    if (this.status === 'ACTIVE') {
      this.deliverableDocuments = this.documents.filter(
        (document: { type: string }) => document.type === 'DELIVERABLE'
      );
    } else if (this.status === 'REVISION_REQUESTED') {
      this.deliverableDocuments = this.documents.filter(
        (document: { type: string }) => document.type === 'REVISION'
      );
    }
    this.modalService.isSubmitDeliverableModalOpen.subscribe((open) => {
      if (this.siteId === open.siteId) {
        this.isReviewOrderSubmitted = open.isOpen;
      }
    });
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  toggleReviewCompletedOpen() {
    this.modalService.toogleOpenSubmitDeliverableModal(this.siteId);
  }

  toggleReviewCompletedClosed() {
    this.modalService.toogleCloseSubmitDeliverableModal();
  }

  submit() {
    this.isSubmitting = true;
    if (this.status === 'ACTIVE') {
      this.submitReview.emit();
    } else if (this.status === 'REVISION_REQUESTED') {
      this.submitRevision.emit();
    }
    this.closeDialog();
    // can't put this in ngOnInit since the title will get updated when
    // the data refreshs and ngOnInit is triggered, so using the behavior subject to
    // store the title in 'state'
    if (this.isAlta) {
      this.modalService.updateSubmissionConfirmationDialogTitle(
        this.status === 'ACTIVE' ? 'Deliverable' : 'Revision'
      );
    } else {
      this.modalService.updateSubmissionConfirmationDialogTitle('Project');
    }
    this.toggleReviewCompletedOpen();
  }
}
